/**
 * sentences — split prose the way the eye does (Plan H).
 *
 * splitSentences: on terminal punctuation followed by space, or on line
 * breaks. Used by GoalList to turn a run-on "Your role" into bullets and by
 * GoalEditor's "Split into lines".
 *
 * asLines: the display form of a field. Explicit line breaks win (one line
 * per break, leading bullet marks stripped); otherwise three or more
 * sentences become one line each; otherwise the text is one line.
 */
export function splitSentences(text) {
  return String(text || "")
    .split(/(?<=[.!?])\s+|\n+/)
    .map(s => s.trim())
    .filter(Boolean);
}

export const BULLET_FROM = 3;

export function asLines(text) {
  const t = String(text || "").trim();
  if (!t) return [];
  if (/\n/.test(t)) {
    return t.split(/\n+/).map(l => l.replace(/^\s*[-•*]\s*/, "").trim()).filter(Boolean);
  }
  const parts = splitSentences(t);
  return parts.length >= BULLET_FROM ? parts : [t];
}
